import {
    computed,
    onMounted,
    ref,
    shallowRef,
} from "vue";


//////////////////////////////////////////////////
//  PWA INSTALL PROMPT
//////////////////////////////////////////////////


type BeforeInstallPromptChoice = {
    outcome  : "accepted" | "dismissed";
    platform : string;
};

type BeforeInstallPromptEvent = Event & {
    prompt(): Promise<void>;
    userChoice: Promise<BeforeInstallPromptChoice>;
};

type StandaloneNavigator = Navigator & {
    standalone?: boolean;
};

const installPrompt = shallowRef<BeforeInstallPromptEvent | null>(null);
const installed = ref(false);
let listenersRegistered = false;

function isStandalone() {
    if (typeof window === "undefined")
        return false;

    const navigatorWithStandalone = window.navigator as StandaloneNavigator;

    return window.matchMedia("(display-mode: standalone)").matches
        || navigatorWithStandalone.standalone === true;
}

function registerInstallListeners() {
    if (listenersRegistered)
        return;

    listenersRegistered = true;
    installed.value = isStandalone();

    window.addEventListener("beforeinstallprompt", (event) => {
        event.preventDefault();
        installPrompt.value = event as BeforeInstallPromptEvent;
    });

    window.addEventListener("appinstalled", () => {
        installed.value = true;
        installPrompt.value = null;
    });
}

export function usePwaInstallPrompt() {
    onMounted(registerInstallListeners);

    const canInstall = computed(() => installPrompt.value !== null && !installed.value);

    async function install() {
        const prompt = installPrompt.value;

        if (!prompt)
            return;

        await prompt.prompt();
        await prompt.userChoice;

        installPrompt.value = null;
    }

    return {
        canInstall,
        install,
    };
}
